import { render, staticRenderFns } from "./VueMap.vue?vue&type=template&id=56a42fc0"
import script from "./VueMap.vue?vue&type=script&lang=js"
export * from "./VueMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports